import { AlgoliaSearchParams } from "@omni/types/api/search/algolia/search/algoliaSearchParams.model";
import { SearchResultProductTileConfig } from "@omni/types/components/props/searchResults.props";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type SearchResultsContextValue = {
    algoliaSearchParameters?: AlgoliaSearchParams;
    productTileConfig?: SearchResultProductTileConfig;
    showFacets?: boolean;
};

type SearchResultsContextProviderProps = {
    algoliaSearchParameters?: AlgoliaSearchParams;
    productTileConfig?: SearchResultProductTileConfig;
    showFacets?: boolean;
    children: ReactNode;
};

export const SearchResultsContext = createContext<
    SearchResultsContextValue | undefined
>(undefined);
SearchResultsContext.displayName = "SearchResultsContext";

export const SearchResultsContextProvider = ({
    algoliaSearchParameters,
    productTileConfig,
    showFacets,
    children
}: SearchResultsContextProviderProps) => {
    return (
        <SearchResultsContext
            value={{
                algoliaSearchParameters,
                productTileConfig,
                showFacets
            }}
        >
            {children}
        </SearchResultsContext>
    );
};

export const useSearchResultsContext = () => {
    const context = use<SearchResultsContextValue | undefined>(
        SearchResultsContext
    );

    if (!isDefined(context)) {
        throw new Error(`${SearchResultsContext.displayName} is undefined.`);
    }

    return context;
};
